export { default } from "./MHALocation";
